var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNpEmail22582539354F6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#9354F6",
    width: "100pt",
    height: "100pt",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m100 75.355v-46.07l-26.07 20.715z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 22.5 45 34.645c3.2148 2.5 7.8555 2.5 11.07 0l43.93-34.645c0-3.9297-1.7852-7.5-6.4297-7.5h-87.145c-4.2852 0-6.4297 3.5703-6.4297 7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.43 53.215-30.355 28.57c1.4297 1.7852 2.8555 3.2148 5.3555 3.2148h87.145c2.5 0 3.9297-1.4297 5.3555-3.2148l-29.285-28.57-10.355 8.2148c-5 3.9297-12.5 3.9297-17.5 0l-10.355-8.2148z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 29.285v46.07l27.145-25.355z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNpEmail22582539354F6);
export default __webpack_public_path__ + "static/media/np_email_2258253_9354F6.934ebc93c07b92ec12c639fe10f953dc.svg";
export { ForwardRef as ReactComponent };